import React, { useState, useEffect } from 'react';
import api from '../api';
import Layout from '../components/Layout';

export default function Messages() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchMessages = async () => {
    setLoading(true);
    try {
      const res = await api.get('/messages/');
      setMessages(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm('Hapus pesan ini?')) return;
    try {
      await api.delete(`/messages/${id}`);
      fetchMessages();
    } catch (err) {
      alert(err.response?.data?.error || 'Gagal menghapus pesan');
    }
  };

  return (
    <Layout>
      <h1 style={{ fontSize: 28, fontWeight: 900, fontStyle: 'italic', marginBottom: 24 }}>Moderasi Pesan</h1>

      {loading ? (
        <p style={{ color: '#8B92A0' }}>Memuat...</p>
      ) : messages.length === 0 ? (
        <p style={{ color: '#8B92A0' }}>Belum ada pesan.</p>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {messages.map((m) => (
            <div key={m.id} style={{ background: '#1C2128', border: '1px solid #262b33', borderRadius: 8, padding: 16 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12, flexWrap: 'wrap' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ display: 'flex', gap: 8, alignItems: 'baseline' }}>
                    <span style={{ fontWeight: 700, fontSize: 14 }}>{m.member_name}</span>
                    <span style={{ color: '#D02127', fontSize: 10, fontWeight: 700, textTransform: 'uppercase' }}>{m.member_position}</span>
                  </div>
                  <p style={{ fontSize: 14, marginTop: 6, color: '#c8ccd3' }}>{m.message}</p>
                  <p style={{ color: '#5a616e', fontSize: 11, marginTop: 6 }}>{new Date(m.created_at).toLocaleString('id-ID')}</p>
                </div>
                <button
                  onClick={() => handleDelete(m.id)}
                  style={{ background: 'rgba(208,33,39,0.15)', color: '#D02127', border: 'none', padding: '6px 14px', borderRadius: 6, fontSize: 12, fontWeight: 700, cursor: 'pointer' }}
                >
                  Hapus
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </Layout>
  );
}
